import { Injectable } from '@angular/core';

export type WorkerExecutionPreference = 'vps' | 'runpod';

const EXECUTION_PREFERENCE_STORAGE_KEY = 'network-planner.execution-preference';

@Injectable({ providedIn: 'root' })
export class WorkerExecutionPreferenceService {
  getExecutionPreference(): WorkerExecutionPreference {
    if (typeof localStorage === 'undefined') {
      return 'vps';
    }
    const raw = (localStorage.getItem(EXECUTION_PREFERENCE_STORAGE_KEY) || '').trim().toLowerCase();
    if (raw === 'vps' || raw === 'runpod') {
      return raw;
    }
    return 'vps';
  }

  setExecutionPreference(value: WorkerExecutionPreference): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    localStorage.setItem(EXECUTION_PREFERENCE_STORAGE_KEY, value);
  }
}